<template>
  <div>
    <div class="my-main-top">
        <div v-if="!loginState" class="profile-box">
          <a href="#" @click.prevent="moveToLogin()" class="profile-link">
            <span class="profile-img">
                <img :src="defaultImage" :alt="defaultImageAlt + '프로필 이미지'">
            </span>
            <span class="profile-txt" v-if="!loginState">
              <span class="profile-txt01">
                <span>로그인하세요</span>
              </span>
              <span class="profile-txt02">지금 바로 웨이브!</span>
            </span>
          </a>
        </div>
        <div v-if="loginState" class="profile-box">
          <a href="#" @click.prevent="showUserInfo"  class="profile-link">
            <span class="profile-img">
              <img :src="'https://' + profileImage" :alt="profileAlt">
            </span>
            <span class="profile-txt">
              <span class="profile-txt01">
                <span>{{name}}</span>
                <span>님</span>
              </span>
            </span>
          </a>
          <div v-if="!hasTooltip" class="profile-tooltip">
            <span>새로워진 프로필 이미지를</span>
            <span>확인해보세요</span>
          </div>
        </div>
        <!-- 로그인 후, 프로필 우측 > 알림, 설정 아이콘 -->
        <div v-if="loginState" class="util-box">
          <a v-if="!isWavveOn" href="#"  @click.prevent="showAlarm" class="util-alarm">
            <PushEmptyIcon v-if="!isNewAlarms"></PushEmptyIcon>
            <PushIcon v-else></PushIcon>
            <span class="a11y-hidden">알림</span>
          </a>
          <a href="#" @click.prevent="moveToSetting()" class="util-settings">
            <SettingIcon></SettingIcon>
            <span class="a11y-hidden">설정</span>
          </a>
        </div>
    </div>

    <!-- 나의 이용권 -->
    <div class="my-voucher" v-if="hasMyPassList">
      <a href="#" @click.prevent="moveToUrl('subscription_ticket')">
        <span>나의 이용권</span>
        <span v-html="voucherInfo"></span>
      </a>
    </div>
    <!-- /나의 이용권 -->

    <div v-if="isWavveOn" class="wavveon-list">
      <wavve-on-introduce />
    </div>
    <template v-else>
      <template v-if="!loginState">
        <!-- 로그인 전, 회원가입 유도 -->
        <div class="login-state-custom">
          <span class="login-state-custom-txt">회원가입하면 지상파 포함 80 여개 LIVE 채널 무료!</span>
          <a href="https://member.wavve.com/mobile/account" class="login-state-custom-link">
            <span>회원가입</span>
            <NextButtonWhite></NextButtonWhite>
          </a>
        </div>
        <div class="my-main-login-txt">
          <span>로그인 후 취향분석, 시청내역, 찜, 관심 프로그램,</span>
          <span>다운로드 콘텐츠, 구매콘텐츠를 이용할 수 있습니다.</span>
        </div>
      </template>
      <template v-else>
        <template v-if="hasPromotion">
          <div class="login-state-custom">
            <p class="login-state-custom-txt">
              <span>{{ promotionText1 }} {{ promotionText2 }}</span>
            </p>
            <a href="#" class="login-state-custom-link" @click.prevent="clickPromotion()">
              <span>{{promotionButtonName}}</span>
              <NextButtonWhite></NextButtonWhite>
            </a>
          </div>
        </template>
        <template v-else>
          <div v-if="hasMyPassList" class="login-state-custom">
            <a href="#" class="login-state-custom-link" @click.prevent="moveToTaste()">
              <span>내 취향 확인해보기</span>
              <NextButtonWhite></NextButtonWhite>
            </a>
          </div>
          <div v-else class="login-state-custom">
            <p class="login-state-custom-txt">
              <span>현재 보유하신 이용권이 없습니다.</span>
            </p>
            <a href="#" class="login-state-custom-link"  @click.prevent="moveToVoucher()">
              <span>구매하기</span>
              <NextButtonWhite></NextButtonWhite>
            </a>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import utils from '@/common/util/utils'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import SettingIcon from '@/assets/svg/common/ic-setup.svg'
import PushEmptyIcon from '@/assets/svg/common/ic-push-empty.svg'
import { UserService } from '@/common/api/api.service'
import { mapMutations, mapGetters } from 'vuex'
import { filter, get, replace } from 'lodash'
import { URL_COOKIE_DOMAIN } from '@/common/constant'
import WavveOnIntroduce from '@/components/lnb/mypooq/WavveOnIntroduce'
import { WavveOnProfileImageInfo } from '@/common/util/common'
import PushIcon from '@/assets/svg/common/ic-push.svg'
import {
  PATH_NAME_ADULT_SETTINGS,
  PATH_NAME_ALARM_NOTICE_LIST,
  PATH_NAME_LNB_USER_INFO, PATH_NAME_SUBSCRIPTION_TICKET,
  PATH_NAME_TASTE_ANALYSIS, PATH_NAME_VOUCHER
} from '@/common/router.const'
export default {
  name: 'TemplateUserInfo',
  components: {
    NextButtonWhite,
    WavveOnIntroduce,
    SettingIcon,
    PushEmptyIcon,
    PushIcon
  },
  data () {
    return {
      isNewAlarms: false,
      profileImage: utils.cookies.userInfo('profileimage'),
      name: '회원님',
      loginState: utils.cookies.getCredential() !== 'none',
      isWavveOn: utils.cookies.isPooqZone(),
      myPassList: [],
      promotionList: [],
      hasTooltip: utils.cookies.getItem('profile-tooltip') === '1',
      defaultImage: require('../../../assets/images/ci-pooq-id.png'),
      defaultImageAlt: 'wavve',
      wavveonType: utils.cookies.getPooqZoneType(),
      profileAlt: utils.cookies.userInfo('alt'),
      voucherInfo: ''
    }
  },
  computed: {
    ...mapGetters(['csInfo']),
    promotionText1 () {
      return get(this.promotionList, '0.text1', '')
    },
    promotionText2 () {
      return get(this.promotionList, '0.text2', '')
    },
    promotionButtonName () {
      return get(this.promotionList, '0.button', '')
    },
    hasPromotion () {
      return this.promotionList.length > 0
    },
    hasMyPassList () {
      return this.myPassList.length > 0
    }
  },
  methods: {
    ...mapMutations({ showAlarms: 'showAlarms' }),
    showAlarm () {
      this.$router.push({ name: PATH_NAME_ALARM_NOTICE_LIST })
    },
    moveToUrl (name) {
      this.$router.replace({ name: name })
    },
    moveToLogin () {
      this.$router.replace(`/login?referer=${this.$route.fullPath.replace(location.origin, '')}`)
    },
    clickPromotion () {
      utils.common.clickLink(get(this.promotionList, '0.link', ''))
    },
    moveToTaste () {
      this.$router.push({ name: PATH_NAME_TASTE_ANALYSIS })
    },
    showUserInfo () {
      this.$router.push({ name: PATH_NAME_LNB_USER_INFO, query: { referer: this.$route.fullPath } })
    },
    async moveToSetting () {
      if (!this.loginState) {
        if (await utils.asyncConfirm('로그인이 필요한 메뉴입니다. 로그인 페이지로 이동하시겠습니까?')) {
          this.$router.replace('/login?referer=/')
        }
      } else {
        this.$router.push({ name: PATH_NAME_ADULT_SETTINGS })
      }
    },
    init () {
      this.name = utils.cookies.userInfo('profilename') || '회원님'
      UserService.getUserSummary().then(({ data }) => {
        this.promotionList = get(data, 'promotion', [])
        this.myPassList = get(data, 'mypass', [])
        const myPass = get(filter(this.myPassList, (mypass, index) => index === 0), '0', {})
        this.voucherInfo = get(myPass, 'producttext', '') + ' ' +
          replace(get(myPass, 'attributetext', ''), new RegExp('\\$O\\$', 'g'), '<i class="icon-dotted"></i>')
      })
      UserService.getAlarmsNewCount().then(({ data }) => {
        this.isNewAlarms = data.count > 0
      })
      if (this.isWavveOn) {
        this.defaultImage = require('../../../assets/images/' + get(WavveOnProfileImageInfo(), 'image', ''))
        this.defaultImageAlt = get(WavveOnProfileImageInfo(), 'imageAlt', '')
      }
    },
    moveToVoucher () {
      this.$router.push({ name: PATH_NAME_VOUCHER })
    }
  },
  created () {
    this.init()
    if (!this.hasTooltip && this.loginState) {
      const expires = new Date()
      expires.setFullYear(expires.getFullYear() + 1)
      utils.cookies.setItem('profile-tooltip', '1', expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
    }
  },
  watch: {
    csInfo () {
      this.init()
    }
  }
}
</script>
